import styled from 'styled-components'

const ContentDiv = styled.div`
	width: 600px;
	display: flex;
	flex-direction: column;
	gap: 30px;
	padding: 20px 0;
`

const FormDiv = styled.div`
	display: flex;
	flex-direction: column;
	gap: 15px;

	& > input {
		width: 100%;
		height: 50px;
		border: 1px solid #c2c2c2;
		border-radius: 5px;
		padding: 0 15px;
		font-size: 14px;

		&::placeholder {
			color: #c2c2c2;
		}
	}
`

const BtnDiv = styled.div`
	display: flex;
	justify-content: flex-end;
`

const Style = {
	ContentDiv,
	FormDiv,
	BtnDiv,
}

export default Style
